module.exports = __webpack_public_path__ + "static/media/Icon-star-full.350c3cc2.svg";